import apiClient from './apiClient';

export const getAgentRegistry = () =>
  apiClient.get('/api/agents/registry');

export const getCompanyAgents = (companyId) =>
  apiClient.get(`/api/agents/config/${companyId}`);

export const updateAgentConfig = (companyId, agentName, data) =>
  apiClient.put(`/api/agents/config/${companyId}/${agentName}`, data);

export const bulkUpdateAgents = (companyId, updates) =>
  apiClient.put(`/api/agents/config/${companyId}/bulk`, { updates });

export const triggerAgent = (companyId, agentName, args = {}) =>
  apiClient.post(`/api/agents/run/${companyId}/${agentName}`, args);

export const getRunHistory = (companyId, agentName = null, limit = 50) =>
  apiClient.get(`/api/agents/runs/${companyId}`, { params: { agentName, limit } });

export const getAgentStats = (companyId) =>
  apiClient.get(`/api/agents/runs/${companyId}/stats`);

export const getPlaybook = (companyId, agentName) =>
  apiClient.get(`/api/agents/playbook/${companyId}/${agentName}`);

export const savePlaybook = (companyId, agentName, data) =>
  apiClient.put(`/api/agents/playbook/${companyId}/${agentName}`, data);

export const chatWithAgent = (companyId, agentName, message, conversationId = null) =>
  apiClient.post(`/api/agents/chat/${companyId}/${agentName}`, { message, conversationId });

export const assistantChat = (companyId, message, conversationId = null, pageContext = null) =>
  apiClient.post(`/api/agents/assistant/${companyId}`, { message, conversationId, pageContext });

// Conversation history
export const getConversations = (companyId) =>
  apiClient.get(`/api/agents/conversations/${companyId}`);

export const getConversationById = (companyId, conversationId) =>
  apiClient.get(`/api/agents/conversations/${companyId}/${conversationId}`);

export const deleteConversation = (companyId, conversationId) =>
  apiClient.delete(`/api/agents/conversations/${companyId}/${conversationId}`);

// Org AI Config
export const getAllOrgConfigs = () =>
  apiClient.get('/api/agents/org-config');

export const getOrgConfig = (companyId) =>
  apiClient.get(`/api/agents/org-config/${companyId}`);

export const saveOrgConfig = (companyId, data) =>
  apiClient.put(`/api/agents/org-config/${companyId}`, data);

export const topUpTokens = (companyId, tokens, note = '') =>
  apiClient.post(`/api/agents/org-config/${companyId}/topup`, { tokens, note });

export const resetUsage = (companyId) =>
  apiClient.post(`/api/agents/org-config/${companyId}/reset-usage`);

export const bulkToggleAgents = (companyIds, enabled) =>
  apiClient.post('/api/agents/org-config/bulk-toggle', { companyIds, enabled });

// HITL Suggestions
export const getSuggestions = (companyId, params = {}) =>
  apiClient.get(`/api/agents/suggestions/${companyId}`, { params });

export const handleSuggestion = (companyId, id, action, note = '') =>
  apiClient.patch(`/api/agents/suggestions/${companyId}/${id}`, { action, note });

export const getSingleRun = (companyId, runId) =>
  apiClient.get(`/api/agents/runs/${companyId}/${runId}`);

// Copilot Skills
export const rfqBuilderDraft = (data) =>
  apiClient.post('/api/agent-skills/rfq-builder/draft', data);

export const varianceAnalyze = (data) =>
  apiClient.post('/api/agent-skills/variance-investigator/analyze', data);

export const quotationDraft = (data) =>
  apiClient.post('/api/agent-skills/quotation-drafter/draft', data);

export const budgetGuardCheck = (data) =>
  apiClient.post('/api/agent-skills/budget-guard/check', data);

export const soValidatorValidate = (data) =>
  apiClient.post('/api/agent-skills/so-validator/validate', data);
